import styled from 'styled-components';

export const Container = styled.div`
    position:relative;
    width: 100%;
    height: 100%;
`;

export const SpinnerContainer = styled.div`
    position:absolute;
    left: 50%;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
`;

export const ChildContainer = styled.div`
    pointer-events: ${(props) => (props.disabled ? 'none' : 'initial')};
    opacity: ${(props) => (props.blur ? '0.5' : '1')};
`;
